import React, { useEffect, useState } from "react";
import { SubHeader } from "../../../Containers/SubHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBill } from "@fortawesome/free-solid-svg-icons/faMoneyBill";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TextField from "../../Utils/FormInputs/TextField";
import { bindActionCreators } from "redux";
import * as snackbarActions from "../../../actions/snackbarActions";
import { connect } from "react-redux";
import SmsSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import { BackButton } from "../../Utils/Buttons/DataExportationButton";

import {
  CustomTableCell,
  MuiPaper,
  StickyHeadTable,
} from "../../Utils/Tables/StickyHeaderTable";
import { LoadingGif } from "../../Utils/Loader";
import { formatDate } from "../../Utils/ConvertDate";
import { DateTimeFilter } from "../../Utils/ReusableComponents/DateTimeFilter";
import { Container, RightAlignedContainer } from "../../Utils/styledComponents";
import axios from "axios";
import { config } from "../../../Helpers/env";
import { errorMessages } from "../../../Helpers/ErrorMessages";
import { CustomTablePagination } from "../../Utils/Tables/CustomTable";
import { Link } from "react-router-dom";
import { useCurrency } from "../../../Context/currency-context";
import Toolbar from "@material-ui/core/Toolbar";
import clsx from "clsx";
import { useToolbarStyles } from "../FixedAssets/FixedAssetList";
import { useDebounce } from "../../Lab/useDebounce";
import { DataExportButton } from "../../Utils/Buttons/DataExportationButton";
import {
  useExcelReports,
  usePdfDownload,
} from "../../Utils/ReusableComponents/useExcelExport";
import PageTitle from "../../Utils/smsTitle";
import ReceiveSinglePayment from "./ReceiveSinglePayment";

const DebtorsList = ({ actions, snackbar, match }) => {
  const { customer_id: id, customer_name: name } = match.params;

  useCurrency({ actions, snackbar });
  const [debtors, setDebtors] = useState([]);
  const [state, setState] = useState({
    start_date:"",
    end_date:"",
    search: "",
  });
  const [loading, setLoading] = useState("idle");
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState("idle");
  const [isSubmitDate, setIsSubmitDate] = useState("idle");
  const [openDialog, setOpenDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  // removed unused expense_id
  const [provider_details, setProvider_details] = useState({});
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const { start_date, end_date, search } = state;
  const [debouncedValue] = useDebounce(search, 500);

  const isResolved = isSubmitted === "resolved";

  const handleMakePayment = (invoice) => {
    setSelectedInvoice({
      ...invoice,
      ...provider_details,
    });
    setOpenDialog(true);
  };

  const manipulateData = React.useCallback((arr = []) =>
    arr.map((item) => {
      const year = new Date(item.begin_datetime).getFullYear().toString();
      const current_year = year.slice(-2);

      return {
        ...item,
        year,
        current_year,
        date: formatDate(item.begin_datetime),
        grand_total: Number(item.grand_total || 0).toFixed(2),
        total_bill: Number(item.total_bill || 0).toFixed(2),
        amount_paid: Number(item.amount_paid || 0).toFixed(2),
        visit_id: `${item.visit_id}/${current_year}`,
        action: (
          <>
            <Link
              to={`/invoice-details/${item.visit_id}/${provider_details.provider_id}/${item.claim_status}/${provider_details.provider_type}`}
            >
              <button className="btn btn-sm small-btn sms-info-btn mr-2 mb-1">
                View
              </button>
            </Link>
            <button
              className="btn btn-sm small-btn sms-success-btn mr-2 mb-1"
              onClick={() => handleMakePayment(item)}
            >
              Make Payment
            </button>
            
              <button className="btn btn-sm small-btn btn-danger mb-1">
                 Bad Debt
              </button>
            {/* </Link> */}
          </>
        ),
      };
    }), [provider_details]);

  useEffect(() => {
    (async () => {
      setLoading("pending");
      try {
        const res = await axios.get(`${config.smsUrl}/cbilling/insurance-invoices`, {
          params: {
            start_date,
            end_date,
            search: debouncedValue,
            page: page + 1,
            page_limit: rowsPerPage,
            provider_id: id,
          },
        });

        const _data = res.data;
        setTotal(_data.total_pages);
        setProvider_details(_data.provider_details);
        setDebtors(manipulateData(_data.data ?? []));
        setLoading("success");
      } catch (e) {
        errorMessages(e, null, actions);
        setLoading("error");
      }
    })();
  }, [isResolved, page, rowsPerPage, debouncedValue, actions, start_date, end_date, id, manipulateData]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChange = (e) => setState({ ...state, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (start_date && end_date) {
      setIsSubmitDate("pending");
      setLoading("pending");
      axios
        .get(`${config.smsUrl}/cbilling/insurance-invoices`, {
          params: {
            start_date,
            end_date,
            search: debouncedValue,
            page: page + 1,
            page_limit: rowsPerPage,
            provider_id: id,
          },
        })
        .then((res) => {
          const _data = res.data;
          setDebtors(manipulateData(_data.data ?? []));
          setTotal(_data.total_pages);
          setProvider_details(_data.provider_details);
          setIsSubmitDate("resolved");
          setLoading("success");
        })
        .catch((err) => {
          errorMessages(err, null, actions);
          setIsSubmitDate("rejected");
          setLoading("error");
        });
    }
  };

  const { openBar, type, message } = snackbar;
  const isPending = isSubmitDate === "pending";
  const isLoading = loading === "pending";
  const isSuccess = loading === "success";
  const isError = loading === "error";

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, debtors.length);

  const pagination = (
    <CustomTablePagination
      colSpan={3}
      page={page}
      rowsPerPage={rowsPerPage}
      count={total}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      isTotalCount
    />
  );

  const headData = [
    { id: "date", label: "Visit Date" },
    { id: "visit_id", label: "Invoice No" },
    { id: "patient_number", label: "Patient No." },

    { id: "name", label: "Patient Name" },
    { id: "currency_symbol", label: "Currency" },
    { id: "co_pay_discount", label: "CO-Payment (%)" },
    { id: "insurance_discount", label: "Insurance Discount (%)" },
    { id: "total_bill", label: "Total Bill" },
    { id: "amount_paid", label: "Amount Paid" },
    { id: "grand_total", label: "Balance" },
    { id: "action", label: "Action" },
  ];

  const excelObj = {
    file_name: "Expenses",
    params: { download: 2, start_date, end_date },
    url: "accounting/debtors/export",
  };

  const pdfObj = {
    file_name: "Expenses",
    params: { download: 1, start_date, end_date },
    url: "accounting/debtors/export",
  };

  const { exportExcel, isLoading: isLoadingExcel } = useExcelReports(actions, excelObj);
  const { exportPdf, isLoading: isLoadingPdf } = usePdfDownload(actions, pdfObj);

  const classes = useToolbarStyles();
  const title = `${name} Insurance Client List`;

  return (
    <div className="journals debtors-container">
      {/* Inline styles as <style> */}
      <style>{`
  .debtors-container {
    padding: 1rem;
    background: #f9fafb;
    min-height: 100vh;
  }

  /* Export button wrapper */
  .export-btn-wrapper {
    margin-bottom: 1rem;
  }

  /* Table styling */
  .journals .MuiPaper-root {
    padding: 1rem;
    border-radius: 8px;
  }

  .journals table {
    width: 100%;
    border-collapse: collapse;
  }

  .journals th,
  .journals td {
    text-align: left;
    padding: 0.75rem;
    border-bottom: 1px solid #e5e7eb;
  }

  .journals th {
    background-color: #f3f4f6;
    font-weight: 600;
    color: #374151;
  }

  .journals tr:hover {
    background-color: #f9fafb;
  }

  /* Button Base */
  .btn {
    display: inline-block;
    font-weight: 500;
    text-align: center;
    padding: 0.4rem 0.75rem;
    font-size: 0.875rem;
    border-radius: 6px;
    cursor: pointer;
    border: none;
    transition: all 0.2s ease-in-out;
  }

  /* Small button variation */
  .btn-sm {
    font-size: 0.75rem;
    padding: 0.3rem 0.6rem;
  }

  /* Margin utilities */
  .mr-2 {
    margin-right: 0.5rem;
  }

  .mb-1 {
    margin-bottom: 0.25rem;
  }

  /* Custom Buttons */
  .sms-info-btn {
    background-color: #3b82f6; /* blue */
    color: white;
  }
  .sms-info-btn:hover {
    background-color: #2563eb;
  }

  .sms-success-btn {
    background-color: #10b981; /* green */
    color: white;
  }
  .sms-success-btn:hover {
    background-color: #059669;
  }

  .btn-danger {
    background-color: #ef4444; /* red */
    color: white;
  }
  .btn-danger:hover {
    background-color: #dc2626;
  }

  /* Responsive table adjustments */
  @media (max-width: 768px) {
    .journals th,
    .journals td {
      padding: 0.5rem;
      font-size: 0.85rem;
    }
    .export-btn-wrapper {
      text-align: right;
      margin-top: 0.5rem;
    }
  }
`}</style>


      <PageTitle title="Invoiced Bills" />
      <SubHeader title={title} subTitle="Invoices">
        <FontAwesomeIcon icon={faMoneyBill} />
      </SubHeader>

      <Container>
        <RightAlignedContainer>
          {/* Payments button removed, only export buttons remain */}
          <BackButton
            to={`/customerreceivables`}
            text="Customer Bills"
            data-testid="billed-invoices-receipt-back-button"
          />
          <div className="export-btn-wrapper">
            <DataExportButton
              isLoading={isLoadingExcel || isLoadingPdf}
              downLoadPdf={exportPdf}
              exportCsv={exportExcel}
            />
          </div>
        </RightAlignedContainer>

        <SmsSnackbar
          variant={type}
          handleCloseBar={() => actions.snackbarActions.hideSnackbar()}
          open={openBar}
          message={message}
        />

        <DateTimeFilter
          {...{
            start_date,
            end_date,
            handleChange,
            submitted,
            handleSubmit,
            isPending,
            type: "date",
          }}
        />

        <MuiPaper>
          <Toolbar className={clsx(classes.root)}>
            <div className="col-md-4">
              <TextField
                onChange={handleChange}
                type="text"
                value={search}
                name="search"
                id="searchValue"
                placeholder="Search debtors..."
              />
            </div>
          </Toolbar>

          {openDialog && selectedInvoice && (
            <ReceiveSinglePayment
              actions={actions}
              openDialog={openDialog}
              setOpenDialog={setOpenDialog}
              isSubmitted={isSubmitted}
              setIsSubmitted={setIsSubmitted}
              providerDetails={selectedInvoice}
            />
          )}

          <StickyHeadTable
            width="100%"
            pagination={pagination}
            data={debtors}
            columns={headData.filter((item) => Boolean(item))}
          >
            {isLoading && (
              <TableRow>
                <TableCell align="center" colSpan={headData.length}>
                  <LoadingGif />
                </TableCell>
              </TableRow>
            )}
            {isSuccess &&
              (debtors.length > 0 ? (
                <>
                  {debtors.map((row) => (
                    <TableRow tabIndex={-1} key={row.expense_id}>
                      {headData.map((col) => (
                        <CustomTableCell key={col.id}>{row[col.id]}</CustomTableCell>
                      ))}
                    </TableRow>
                  ))}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 43 * emptyRows }}>
                      <TableCell colSpan={headData.length} />
                    </TableRow>
                  )}
                </>
              ) : (
                <TableRow>
                  <TableCell align="center" colSpan={headData.length}>
                    No records found
                  </TableCell>
                </TableRow>
              ))}
            {isError && (
              <TableRow>
                <TableCell align="center" colSpan={headData.length}>
                  The server did not return a valid response
                </TableCell>
              </TableRow>
            )}
          </StickyHeadTable>
        </MuiPaper>
      </Container>
    </div>
  );
};

function mapStateToProps(state) {
  const { snackbar } = state;
  return { snackbar };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      snackbarActions: bindActionCreators(snackbarActions, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DebtorsList);
